// ── NAV WIRING ──
document.addEventListener('DOMContentLoaded', function () {
  var shopLink = document.getElementById('nav-shop-link');
  var isHome = document.getElementById('page-home') !== null;

  // Shop link: scroll to shop section if on homepage
  if (shopLink && isHome) {
    shopLink.addEventListener('click', function (e) {
      e.preventDefault();
      var shop = document.getElementById('shop');
      if (shop) shop.scrollIntoView({ behavior: 'smooth' });
    });
  }
});

// ── SHOP FILTERS ──
function filterProducts(type, btn) {
  document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');

  const isAll = type === 'all';
  document.querySelectorAll('.collection-block').forEach(block => {
    block.style.display = (isAll || block.dataset.type === type) ? '' : 'none';
  });

  // Only show collection labels (heading + divider line) in All view
  document.querySelectorAll('.collection-label').forEach(el => {
    el.style.display = isAll ? '' : 'none';
  });
}

// ── FAQ ACCORDION ──
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const answer = this.nextElementSibling;
      const isOpen = answer.classList.contains('open');

      const openAnswers = document.querySelectorAll('.faq-answer.open');
      const hasOpenItem = openAnswers.length > 0;

      // Close all open items
      document.querySelectorAll('.faq-answer').forEach(function (a) { a.classList.remove('open'); });
      document.querySelectorAll('.faq-question').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });

      // If clicking a closed item, wait for close transition then open
      if (!isOpen) {
        const delay = hasOpenItem ? 320 : 0;
        const targetBtn = this;
        setTimeout(function () {
          answer.classList.add('open');
          targetBtn.setAttribute('aria-expanded', 'true');
        }, delay);
      }
    });
  });
});

function refreshCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const badge = document.getElementById('nav-cart-count');
      if (!badge) return;
      if (cart.item_count > 0) {
        badge.textContent = cart.item_count;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    })
    .catch(() => {});
}

document.addEventListener('DOMContentLoaded', function () {
  refreshCartCount();
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', () => setTimeout(refreshCartCount, 800));
  });
});
document.addEventListener('DOMContentLoaded', function () {
  // Show all blocks and labels on load (All is default)
  document.querySelectorAll('.collection-block').forEach(block => {
    block.style.display = '';
  });
  document.querySelectorAll('.collection-label').forEach(el => {
    el.style.display = '';
  });
});

// ── CURRENCY SWITCHER ──
document.addEventListener('DOMContentLoaded', function () {
  const switcher = document.querySelector('.currency-switcher');
  if (!switcher) return;

  const trigger = document.getElementById('currency-trigger');
  const menu = document.getElementById('currency-menu');
  const hiddenInput = document.getElementById('currency-country-code');
  const form = document.getElementById('currency-form');

  function closeMenu() {
    menu.setAttribute('hidden', '');
    trigger.setAttribute('aria-expanded', 'false');
  }
  function openMenu() {
    menu.removeAttribute('hidden');
    trigger.setAttribute('aria-expanded', 'true');
  }

  trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    if (menu.hasAttribute('hidden')) {
      openMenu();
    } else {
      closeMenu();
    }
  });

  menu.querySelectorAll('.currency-option').forEach(function (opt) {
    function selectOption() {
      if (opt.dataset.code === hiddenInput.value) {
        closeMenu();
        return;
      }
      hiddenInput.value = opt.dataset.code;
      form.submit();
    }
    opt.addEventListener('click', selectOption);
    opt.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        selectOption();
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!switcher.contains(e.target)) closeMenu();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });
});
